module.exports = __webpack_public_path__ + "media/stylesheets/images/temp_wolf_planent_kit/card_kit_2-686815a0b10f0faf14897e9f593604ca.png";